import styled from 'styled-components';

export const PageWrapper = styled.div`
  min-height: 100vh;
  background: ${p => p.bg || '#000'};
  padding: 80px 24px 60px;
`;

export const Container = styled.div`
  max-width: 800px;
  margin: 0 auto;
`;

export const BackBtn = styled.button`
  background: none;
  border: 1px solid ${p => p.accent || '#667eea'}44;
  color: ${p => p.accent || '#667eea'};
  border-radius: 8px;
  padding: 8px 16px;
  font-size: 14px;
  cursor: pointer;
  margin-bottom: 32px;
  transition: background 0.15s;
  &:hover { background: ${p => p.accent || '#667eea'}18; }
`;

export const DocTitle = styled.h1`
  color: ${p => p.color || '#fff'};
  font-size: 28px;
  font-weight: 700;
  margin-bottom: 8px;
`;

export const DocVersion = styled.p`
  color: ${p => p.color || '#fff'}66;
  font-size: 13px;
  margin-bottom: 40px;
`;

export const Section = styled.section`
  margin-bottom: 32px;
`;

export const SectionTitle = styled.h2`
  color: ${p => p.accent || '#667eea'};
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 10px;
  padding-bottom: 6px;
  border-bottom: 1px solid ${p => p.accent || '#667eea'}33;
`;

export const SectionText = styled.p`
  color: ${p => p.color || '#fff'}cc;
  font-size: 14px;
  line-height: 1.7;
  white-space: pre-line;
`;
